// extracted by mini-css-extract-plugin
module.exports = {"google-photos-button-container":"GooglePhotosButton_google-photos-button-container__zer46"};